/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * F032 step 7b: the program document as the program page reads it.
 */
import type { ProgrammingProductData } from "../../hooks/useProgrammeLanes";

export type ProgramDoc = ProgrammingProductData & {
  programmingUID: string;
  weeks?: number | null;
  isHistoryAvailable?: boolean;
  releaseAll?: boolean;
};

export type RunsAs = "daily" | "weeks" | "list";

export const runsAs = (program: Pick<ProgramDoc, "programmingType">): RunsAs => {
  switch (program.programmingType?.type) {
    case "reoccurring":
      return "daily";
    case "timeline":
      return "weeks";
    default:
      return "list";
  }
};
